/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampProgramDto } from '../../models/camp-program-dto';
import { CampProgramShowResponse } from '../../models/camp-program-show-response';

export interface PostCampProgramCreate$Params {
      body: CampProgramDto
}

export function postCampProgramCreate(http: HttpClient, rootUrl: string, params: PostCampProgramCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CampProgramShowResponse>> {
  const rb = new RequestBuilder(rootUrl, postCampProgramCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampProgramShowResponse>;
    })
  );
}

postCampProgramCreate.PATH = '/v1/camp-program';
